import { getEventAndEffect } from '@ynap/analytics'
import { getPrice } from '../../analytics'

/**
 * @param {'recent' | 'past'} category One of the following: 'recent', 'past'
 * @param {string} effect
 */
const trackOrderEvent = (category, effect) => {
    const event = `${effect} - ${category} orders`
    return getEventAndEffect(event, effect)
}

/**
 * @param {'recent' | 'past'} category One of the following: 'recent', 'past'
 */
export const trackTrackOrder = (category) => trackOrderEvent(category, 'track my order')

/**
 * @param {'recent' | 'past'} category One of the following: 'recent', 'past'
 * @param {string} externalOrderID
 * @param {string} placedDate
 * @param {string} price
 * @param {string} currencyCode
 * @param {string} countryCode
 */
export const trackViewOrderDetails = ({
    category,
    externalOrderID,
    orderDateRaw,
    price,
    currencyCode,
    countryCode,
}) => {
    return {
        event: `${category} orders - view details`,
        effect: `view details of ${category} order`,
        attributes: {
            orderID: externalOrderID,
            orderDate: orderDateRaw,
            orderTotal: getPrice(price),
            orderCurrency: currencyCode,
            countryCode,
        },
    }
}
